<template>
    <div class="navigation" v-if="isMobile">
        <ul>
            <li 
                v-for="(item, index) in navItems" 
                :key="index" 
                :class="['list', { active: activeIndex === index }]" 
                @click="setActive(index)"
            >
            <router-link :to="item.href">
                <span class="icon"><i :class="item.icon"></i></span>
                <span class="text">{{ item.text }}</span>
            </router-link>
        </li>
      <div class="indicator"></div>
    </ul>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isMobile: false,
        activeIndex: 0,
        navItems: [
            { icon: 'bi bi-house', text: 'Home', href: '/' },
            { icon: 'bi bi-question-circle', text: 'About Us', href: '/about' },
            { icon: 'bi bi-grid', text: 'Services', href: '/services' },
            { icon: 'bi bi-rocket-takeoff', text: 'Works', href: '/works' },
            { icon: 'bi bi-envelope', text: 'Contact', href: '/contact' },
        ],
      };
    },
    mounted() {
        this.handleResize(); // Verifica el tamaño inicial de la pantalla
        window.addEventListener("resize", this.handleResize); // Escucha cambios en el tamaño
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize); // Limpia el listener al desmontar
    },
    methods: {
        setActive(index) {
            this.activeIndex = index; // Cambia el índice activo al hacer clic
        },
      handleResize() {
            this.isMobile = window.innerWidth <= 991; // Cambiar a móvil si la pantalla es menor o igual a 768px
        },
    }
  };
</script>
  
<style scoped>
  
.navigation {
    width: 100%;
    height: 70px;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0px;
    z-index: 99;
}
  
.navigation ul {
    display: flex;
    width: 100%;
}
  
.navigation ul li {
    position: relative;
    list-style: none;
    width: 70px;
    height: 70px;
    z-index: 1;
}
  
.navigation ul li a {
    color: rgb(231, 233, 234);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    text-align: center;
    font-weight: 500;
}
  
.navigation ul li a .icon {
    line-height: 85px;
    font-size: 1.5em;
    transition: 0.5s;
    color: rgb(131, 131, 131);
}
  
.navigation ul li.active a .icon {
    transform: translateY(-32px);
    color: rgb(231, 233, 234);
    transition: 0.5s;
}
  
.navigation ul li a .text {
    position: absolute;
    font-size: 0.75em;
    opacity: 0;
    transition: 0.5s;
}
  
.navigation ul li.active a .text {
    opacity: 1;
    transform: translateY(10px);
}
  
.indicator {
    position: absolute;
    top: -50%;
    width: 70px;
    height: 70px;
    background: #ed1b24;
    border-radius: 50%;
    border: 6px solid #000;
    transition: 0.5s;
}

.indicator::before{
    content: '';
    position: absolute;
    top: 50%;
    left: -22px;
    width: 20px;
    height: 20px;
    background: transparent;
    border-top-right-radius: 30px;
    box-shadow: 1px -10px 0 0 transparent;
}

.indicator::after{
    content: '';
    position: absolute;
    top: 50%;
    right: -22px;
    width: 20px;
    height: 20px;
    background: transparent;
    border-top-left-radius: 30px;
    box-shadow: -1px -10px 0 0 transparent;
}

.navigation ul li:nth-child(1).active ~ .indicator{
    transform: translateX(calc(70px * 0));
}

.navigation ul li:nth-child(2).active ~ .indicator{
    transform: translateX(calc(70px * 1));
}

.navigation ul li:nth-child(3).active ~ .indicator{
    transform: translateX(calc(70px * 2));
}

.navigation ul li:nth-child(4).active ~ .indicator{
    transform: translateX(calc(70px * 3));
}

.navigation ul li:nth-child(5).active ~ .indicator{
    transform: translateX(calc(70px * 4));
}
</style>
  